<script setup lang="ts">
import { useRouter } from "vue-router";
import { ROUTE_BLOG_SEARCH } from "~/constants/routes";


const router = useRouter();
const searchText = ref("");
const isShowSearch = ref(false);
const searchInputWrapper = ref(null);
const searchInput = ref();

const openSearch = () => {
  isShowSearch.value = true;
  searchInput.value.focus();
  onClickOutside(searchInputWrapper, () => {
    isShowSearch.value = false;
    searchText.value = "";
  });
};

const clearSearchText = () => {
  searchText.value = "";
};

const submitSearch = async () => {
  if (searchText.value) {
    router.push({ path: ROUTE_BLOG_SEARCH, query: { q: searchText.value } });
  }
};
</script>
<template>
  <button
    type="button"
    aria-label="Search the blog"
    class="icon-main-search p-[14px] text-[19px] flex items-center justify-center cursor-pointer"
    @click="openSearch"
  />
  <form
    data-algolia-search-form
    role="search"
    method="get"
    :class="{ active: isShowSearch, 'outline outline-2 outline-tertiary-misc-celery': isShowSearch }"
    class="search-form absolute self-center m-auto overflow-hidden w-0 transition-all duration-300 flex flex-row ease-linear z-[2] bg-tertiary-misc-celery rounded-[50px] flex items-center justify-center h-12 [&.active]:w-full [&.active]:visible"
    @submit.prevent="submitSearch"
  >
    <div
      ref="searchInputWrapper"
      class="sm:max-w-[372px] w-full flex bg-primary-cream-100 padding-1 rounded-[50px] relative mx-[13px]"
    >
      <i
        class="icon-main-times z-1 absolute top-2 left-2.5 cursor-pointer text-nl-green-100"
        @click="clearSearchText"
      />
      <input
        ref="searchInput"
        v-model="searchText"
        type="text"
        aria-label="Search input"
        data-algolia-search-input
        class="flex-1 py-1 w-full bg-transparent text-nl-green-100 font-desktop-body-xl pl-[42px] tracking-[0.08em] min-w-0 placeholder-primary-kale-200 focus:outline-none"
        placeholder="Search Blog"
      >
      <input
        id="searchsubmit"
        data-algolia-submit-input
        type="submit"
        class="bg-tertiary-banana-500 hover:bg-tertiary-banana-600 text-nl-green-100 text-desktop-button-s rounded-[50px] w-[106px]"
        value="Search"
      >
    </div>
  </form>
</template>
